import {FC} from 'react'
import Skeleton from 'react-loading-skeleton'

interface TableLoaderProps {
  colSpan?: number
}

export const TableLoader: FC<TableLoaderProps> = ({colSpan}) => {
  return (
    <>
      {Array.from({length: 5}).map((_, index) => (
        <tr key={index} style={{backgroundColor: 'white', padding: 0}} role='row'>
          {Array.from({length: colSpan ?? 9}).map((_, index) => (
            <td key={index} style={{padding: '0 !important'}} role='cell'>
              <Skeleton width={100} height={30} />
            </td>
          ))}
        </tr>
      ))}
    </>
  )
}

TableLoader.defaultProps = {
  colSpan: 9,
}
